// ##### 25-04-24 Komarov
import { DEV_MODE_SET, DEV_MODE_UNSET } from '../constants';

const initialState = false;

export default (state = initialState, action) => {
  // ##### 23-04-05 Komarov
  switch (action.type) {
    case DEV_MODE_SET:
      return action.payload;
    case DEV_MODE_UNSET:
      return action.payload;
    default:
      return state;
  }
};
